export class Icon {
  alt: string;
  src: string;
  constructor(data: Icon) {
    this.alt = data.alt;
    this.src = data.src;
  }
}


export const IconsArray: Icon[] = [
  {
    alt: "default",
    src: ""
  },
  {
    alt: "logo",
    src: "app/assets/icons/logo.svg"
  },
  {
    alt: "airplane",
    src: "app/assets/icons/airplane.svg"
  },
  {
    alt: "hamburger",
    src: "app/assets/icons/hamburger.svg"
  },
  {
    alt: "email",
    src: "app/assets/icons/email.svg"
  },
  {
    alt: "phone",
    src: "app/assets/icons/phone.svg"
  },
  {
    alt: "arrow-right",
    src: "app/assets/icons/arrow-right.svg"
  },
  {
    alt: "antarctica",
    src: "app/assets/icons/antarctica.svg"
  },
  {
    alt: "asia",
    src: "app/assets/icons/asia.svg"
  },
  {
    alt: "australia",
    src: "app/assets/icons/australia.svg"
  },
  {
    alt: "europe",
    src: "app/assets/icons/europe.svg"
  },
  {
    alt: "middle-east",
    src: "app/assets/icons/middle-east.svg"
  },
  {
    alt: "africa",
    src: "app/assets/icons/africa.svg"
  },
  {
    alt: "circle-arrows",
    src: "app/assets/icons/circle-arrows.svg"
  },
  {
    alt: "square-arrow",
    src: "app/assets/icons/square-arrow.svg"
  },
  {
    alt: "fat-arrow",
    src: "app/assets/icons/fat-arrow.svg"
  },
  {
    alt: "middle-east-img",
    src: "app/assets/icons/middle-east.png"
  },
  {
    alt: "prophets-mosque",
    src: "app/assets/icons/prophets-mosque.svg"
  },
  {
    alt: "middle-east-img",
    src: "app/assets/icons/western-wall.svg"
  },
  {
    alt: "north-america",
    src: "app/assets/icons/north-america.svg"
  },
  {
    alt: "arrow-down",
    src: "app/assets/icons/arrow-down.svg"
  },
  {
    alt: "check",
    src: "app/assets/icons/check.svg"
  },
  {
    alt: "magnifier",
    src: "app/assets/icons/magnifier1.svg"
  },
  {
    alt: "cross",
    src: "app/assets/icons/cross.svg"
  },
  {
    alt: "arrow-down-black",
    src: "app/assets/icons/arrow-down-dark.svg"
  },
  {
    alt: "theme",
    src: "app/assets/icons/theme.svg"
  },
  {
    alt: "crossBold",
    src: "app/assets/icons/crossBold.svg"
  },
  {
    alt: "arrowBold",
    src: "app/assets/icons/arrow-bold.svg"
  },
  {
    alt: "camera",
    src: "app/assets/icons/camera.svg"
  },
  {
    alt: "plus",
    src: "app/assets/icons/plus.svg"
  },
  {
    alt: "arrowPage",
    src: "app/assets/icons/arrow-page.svg"
  },
  {
    alt: "arrowPageDouble",
    src: "app/assets/icons/arrow-page-double.svg"
  },
  {
    alt: "cross-close",
    src: "app/assets/icons/cross-close.svg"
  },
  {
    alt: "geo-anchor",
    src: "app/assets/icons/geo-anchor.svg"
  },
  {
    alt: "sort-none",
    src: "app/assets/icons/sort-none.svg"
  },
  {
    alt: "sort-up",
    src: "app/assets/icons/sort-up.svg"
  },
  {
    alt: "sort-down",
    src: "app/assets/icons/sort-down.svg"
  },
  {
    alt: "magnifier2",
    src: "app/assets/icons/magnifier2.svg"
  },
  {
    alt: "formArrow",
    src: "app/assets/icons/formArrow.svg"
  },
  {
    alt: "mapMob",
    src: "app/assets/icons/mapMob.svg"
  },
  {
    alt: "south-america",
    src: "app/assets/icons/south-america.svg"
  },
  {
    alt: "logout",
    src: "app/assets/icons/logout.svg"
  },
  {
    alt: "thin-cross",
    src: "app/assets/icons/thin-cross.svg"
  },
  {
    alt: "thunder",
    src: "app/assets/icons/thunder.svg"
  },
  {
    alt: "home",
    src: "app/assets/icons/home.svg"
  },
  {
    alt: "tiny-arrow",
    src: "app/assets/icons/tiny-arrow.svg"
  },
  {
    alt: "check-feedback",
    src: "app/assets/icons/check-feedback.svg"
  },
  {
    alt: "meal",
    src: "app/assets/icons/meal.svg"
  },
  {
    alt: "logoBorder",
    src: "app/assets/icons/logoBorder.svg"
  },
  {
    alt: "mobileArrowRight",
    src: "app/assets/icons/mobileArrowRight.svg"
  },
  {
    alt: "key",
    src: "app/assets/icons/key.svg"
  },
  {
    alt: "hotelBackArrow",
    src: "app/assets/icons/hotelBackArrow.svg"
  },
  {
    alt: "newAir",
    src: "app/assets/icons/newAir.svg"
  },
];
export const Icons = {
  default: IconsArray[0],
  logo: IconsArray[1],
  airplane: IconsArray[2],
  hamburger: IconsArray[3],
  email: IconsArray[4],
  phone: IconsArray[5],
  arrowRight: IconsArray[6],
  antarctica: IconsArray[7],
  asia: IconsArray[8],
  australia: IconsArray[9],
  europe: IconsArray[10],
  middleEast: IconsArray[11],
  africa: IconsArray[12],
  circleArrows: IconsArray[13],
  squareArrow: IconsArray[14],
  fatArrow: IconsArray[15],
  middleEastImg: IconsArray[16],
  prophetsMosque: IconsArray[17],
  westernWall: IconsArray[18],
  northAmerica: IconsArray[19],
  arrowDown: IconsArray[20],
  check: IconsArray[21],
  magnifier: IconsArray[22],
  cross: IconsArray[23],
  arrowDownBlack: IconsArray[24],
  theme: IconsArray[25],
  crossBold: IconsArray[26],
  arrowBold: IconsArray[27],
  camera: IconsArray[28],
  plus: IconsArray[29],
  arrowPage: IconsArray[30],
  arrowPageDouble: IconsArray[31],
  crossClose: IconsArray[32],
  geoAnchor: IconsArray[33],
  sortNone: IconsArray[34],
  sortUp: IconsArray[35],
  sortDown: IconsArray[36],
  magnifier2: IconsArray[37],
  formArrow: IconsArray[38],
  mapMob: IconsArray[39],
  southAmerica: IconsArray[40],
  logout: IconsArray[41],
  thinClose: IconsArray[42],
  thunder: IconsArray[43],
  home: IconsArray[44],
  tinyArrow: IconsArray[45],
  checkFeedback: IconsArray[46],
  meal: IconsArray[47],
  logoBorder: IconsArray[48],
  mobileArrowRight: IconsArray[49],
  key: IconsArray[50],
  hotelBackArrow: IconsArray[51],
  newAir: IconsArray[52],
}

export const IconsCloudsArray: Icon[] = [
  {
    alt: "Extreme-Weather-Conditions",
    src: "app/assets/icons/clouds/Extreme-Weather-Conditions.svg"
  },
  {
    alt: "Unique-nature",
    src: "app/assets/icons/clouds/Unique-nature.svg"
  },
  {
    alt: "Untouched-Landscapes",
    src: "app/assets/icons/clouds/Untouched-Landscapes.svg"
  },
  {
    alt: "Timeless-Temples",
    src: "app/assets/icons/clouds/Timeless-Temples.svg"
  },
  {
    alt: "Breathtaking-Natural-Wonders-Asia",
    src: "app/assets/icons/clouds/Breathtaking-Natural-Wonders-Asia.svg"
  },
  {
    alt: "World-Class-Culinary",
    src: "app/assets/icons/clouds/World-Class-Culinary.svg"
  },
  {
    alt: "Charming-Islands",
    src: "app/assets/icons/clouds/Charming-Islands.svg"
  },
  {
    alt: "Unique-Legacy",
    src: "app/assets/icons/clouds/Unique-Legacy.svg"
  },
  {
    alt: "Underwater-Landscapes",
    src: "app/assets/icons/clouds/Underwater-Landscapes.svg"
  },
  {
    alt: "Majestic-Wildlife",
    src: "app/assets/icons/clouds/Majestic-Wildlife.svg"
  },
  {
    alt: "Tribal-Arts",
    src: "app/assets/icons/clouds/Tribal-Arts.svg"
  },
  {
    alt: "Savannah",
    src: "app/assets/icons/clouds/Savannah.svg"
  },
  {
    alt: "Timeless-Historic-Cities",
    src: "app/assets/icons/clouds/Timeless-Historic-Cities.svg"
  },
  {
    alt: "Breathtaking-Architectural-Wonders",
    src: "app/assets/icons/clouds/Breathtaking-Architectural-Wonders.svg"
  },
  {
    alt: "World-Class-Art",
    src: "app/assets/icons/clouds/World-Class-Art.svg"
  },
  {
    alt: "Holy-Sites",
    src: "app/assets/icons/clouds/Holy-Sites.svg"
  },
  {
    alt: "Ancient-Civilizations",
    src: "app/assets/icons/clouds/Ancient-Civilizations.svg"
  },
  {
    alt: "Archaeological-Sites",
    src: "app/assets/icons/clouds/Archaeological-Sites.svg"
  },
  {
    alt: "Rich-Indigenous-Heritage",
    src: "app/assets/icons/clouds/Rich-Indigenous-Heritage.svg"
  },
  {
    alt: "Dynamic-Urban-Experiences",
    src: "app/assets/icons/clouds/Dynamic-Urban-Experiences.svg"
  },
  {
    alt: "National-Parks",
    src: "app/assets/icons/clouds/National-Parks.svg"
  },
  {
    alt: "Majestic-Ancient-Ruins",
    src: "app/assets/icons/clouds/Majestic-Ancient-Ruins.svg"
  },
  {
    alt: "Colorful-Cultural-Festivals",
    src: "app/assets/icons/clouds/Colorful-Cultural-Festivals.svg"
  },
  {
    alt: "Breathtaking-Natural-Wonders-SA",
    src: "app/assets/icons/clouds/Breathtaking-Natural-Wonders-SA.svg"
  },
  {
    alt: "maple-leaf",
    src: "app/assets/icons/clouds/maple-leaf.svg"
  },
  {
    alt: "ice",
    src: "app/assets/icons/clouds/ice.svg"
  },
  {
    alt: "sun",
    src: "app/assets/icons/clouds/sun.svg"
  },
  {
    alt: "UNESCO-World",
    src: "app/assets/icons/clouds/UNESCO-World.svg"
  },
  {
    alt: "Historical-Monuments",
    src: "app/assets/icons/clouds/Historical-Monuments.svg"
  },
  {
    alt: "Crossroads-of-Civilizations",
    src: "app/assets/icons/clouds/Crossroads-of-Civilizations.svg"
  },
  {
    alt: "Fast-track",
    src: "app/assets/icons/clouds/Fast-track.svg"
  },
  {
    alt: "Meet-&-greet",
    src: "app/assets/icons/clouds/Meet-&-greet.svg"
  },
  {
    alt: "Airport-lounge",
    src: "app/assets/icons/clouds/Airport-lounge.svg"
  },
]

export const IconsClouds = {
  ExtremeWeatherConditions: IconsCloudsArray[0],
  UniqueNature: IconsCloudsArray[1],
  UntouchedLandscapes: IconsCloudsArray[2],
  TimelessTemples: IconsCloudsArray[3],
  BreathtakingNaturalWondersAsia: IconsCloudsArray[4],
  WorldClassCulinary: IconsCloudsArray[5],
  CharmingIslands: IconsCloudsArray[6],
  UniqueLegacy: IconsCloudsArray[7],
  UnderwaterLandscapes: IconsCloudsArray[8],
  MajesticWildlife: IconsCloudsArray[9],
  TribalArts: IconsCloudsArray[10],
  Savannah: IconsCloudsArray[11],
  TimelessHistoricCities: IconsCloudsArray[12],
  BreathtakingArchitecturalWonders: IconsCloudsArray[13],
  WorldClassArt: IconsCloudsArray[14],
  HolySites: IconsCloudsArray[15],
  AncientCivilizations: IconsCloudsArray[16],
  ArchaeologicalSites: IconsCloudsArray[17],
  RichIndigenousHeritage: IconsCloudsArray[18],
  DynamicUrbanExperiences: IconsCloudsArray[19],
  NationalParks: IconsCloudsArray[20],
  MajesticAncientRuins: IconsCloudsArray[21],
  ColorfulCulturalFestivals: IconsCloudsArray[22],
  BreathtakingNaturalWondersSA: IconsCloudsArray[23],
  mapleLeaf: IconsCloudsArray[23],
  ice: IconsCloudsArray[24],
  sun: IconsCloudsArray[25],
  UNESCOWorld: IconsCloudsArray[26],
  HistoricalMonuments: IconsCloudsArray[27],
  CrossroadsOfCivilizations: IconsCloudsArray[28],
  FastTrack: IconsCloudsArray[29],
  MeetGreet : IconsCloudsArray[30],
  AirportLounge : IconsCloudsArray[31],
}
